export default "__VITE_ASSET__8L3MCqqC__"